<template>
  <div>
    <div class="row">
      <div class="col-10">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
                ref="fullCalendar"
                :options="calendarOptions"
              ></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="showModal"
      title="Προσθήκη"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      centered
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="mt-3">Ώρα έναρξης</label>
              <date-picker
                v-model="event.start_time"
                format="HH:mm"
                value-type="format"
                type="time"
                placeholder="HH:mm"
                required
                @change="handleStartTimeChange"
                :class="{ 'is-invalid': errors.start_time }"
              ></date-picker>
              <div
                v-if="errors.start_time"
                class="invalid-feedback"
              >{{ errors.end_date }}</div>

            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="mt-3">Ώρα λήξης</label>
              <date-picker
                v-model="event.end_time"
                format="HH:mm"
                value-type="format"
                type="time"
                placeholder="HH:mm"
                @change="handleEndTimeChange"
                :class="{ 'is-invalid': errors.end_time }"
              ></date-picker>
              <div
                v-if="errors.end_time"
                class="invalid-feedback"
              >{{ errors.end_time }}</div>
            </div>
          </div>
          <div class="col-md-8 mt-3">
            <div class="mt-3">
              <label>Νυχτερινό ωράριο</label>
              <b-form-checkbox
                v-model="event.is_night_shift"
                class="mb-3 custom-checkbox"
                plain
                @change="handleIsNightShift"
              ></b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <b-button
            variant="light"
            @click="hideModal"
          >Κλείσιμο</b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
          >Καταχώριση</b-button>
        </div>
      </form>
    </b-modal>

    <!-- Edit Modal -->
    <b-modal
      v-model="eventModal"
      title="Edit Event"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
      centered
    >
      <div slot="modal-title">
        Επεξεργασία
      </div>
      <form @submit.prevent="editSubmit">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="mt-3">Ώρα έναρξης</label>
              <date-picker
                v-model="editevent.start_time"
                format="HH:mm"
                value-type="format"
                type="time"
                placeholder="HH:mm"
                required
                :class="{ 'is-invalid': errors.start_time }"
                @change="handleEditStartTimeChange"
              ></date-picker>
              <div
                v-if="errors.start_time"
                class="invalid-feedback"
              >{{ errors.start_time }}</div>

            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="mt-3">Ώρα λήξης</label>
              <date-picker
                v-model="editevent.end_time"
                format="HH:mm"
                value-type="format"
                type="time"
                placeholder="HH:mm"
                :class="{ 'is-invalid': errors.end_time }"
                @change="handleEditEndTimeChange"
              ></date-picker>
              <div
                v-if="errors.end_time"
                class="invalid-feedback"
              >{{ errors.end_time }}</div>
            </div>
          </div>
          <div class="col-md-8 mt-3">
            <div class="mt-3">
              <label>Νυχτερινό ωράριο</label>
              <b-form-checkbox
                v-model="editevent.is_night_shift"
                class="mb-3 custom-checkbox"
                plain
                @change="handleEditIsNightShift"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="text-end p-3">
          <b-button
            variant="light"
            @click="closeModal"
          >Κλείσιμο
          </b-button>
          <b-button
            class="ms-1"
            variant="danger"
            @click="confirm"
          >Διαγραφή</b-button>
          <b-button
            class="ms-1"
            variant="success"
            @click="editSubmit"
          >Αποθήκευση</b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

// import { calendarEvents, categories } from "./data-calendar";
import grLocale from "@fullcalendar/core/locales/el";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import session from "../../../../../api/session";

/**
 * Calendar component
 */
export default {
  name: "Calendar",
  components: {
    FullCalendar,
    DatePicker,
  },
  data() {
    return {
      calendarEvents: [],
      calendarOptions: {
        // height: 650,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          // right: "dayGridMonth,dayGridWeek,dayGridDay",
          right: "dayGridMonth",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        locale: grLocale,
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        // initialEvents: this.parseScheduleCalendarData(),
        editable: true,
        droppable: false,
        eventResizableFromStart: false,
        // dateClick: this.dateClicked,
        eventClick: this.editEvent,
        eventsSet: this.handleEvents,
        eventResize: this.handleEventResize,
        weekends: true,
        selectable: true,
        select: this.handleDateRangeSelect,
        selectMirror: true,
        dayMaxEvents: true,
        // datesSet: this.handleDatesSet,
        eventDrop: this.handleEventDrop,
        events: this.fetchWorkingSchedule,
      },
      currentEvents: [],
      showModal: false,
      eventModal: false,
      // categories: categories,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        start_time: "",
        end_time: "",
        is_night_shift: false,
      },
      editevent: {
        start_time: "",
        end_time: "",
        is_night_shift: "",
      },
      errors: {
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
      },
    };
  },

  validations: {
    event: {
      start_time: { required },
      end_time: { required },
    },
    isValidForm: false,
  },

  methods: {
    async fetchWorkingSchedule(info, successCallback, failureCallback) {
      const paramsObj = {
        start_date: moment(info.start).format("YYYY-MM-DD"),
        end_date: moment(info.end).format("YYYY-MM-DD"),
      };
      const searchParams = new URLSearchParams(paramsObj);

      await session
        .get(
          `api/${
            this.$route.params.id
          }/calendar-schedule/?${searchParams.toString()}`
        )
        .then((resp) => {
          const events = this.parseEventsFromResponse(resp.data);
          successCallback(events);
        })
        .catch((e) => {
          console.log(e);

          failureCallback(e);
        });
    },
    parseEventsFromResponse(data) {
      const parsedData = data.map((e) => ({
        id: e.id,
        title: `${moment(e.start_time, "HH:mm").format("HH:mm")}-${moment(
          e.end_time,
          "HH:mm"
        ).format("HH:mm")} ${e.is_night_shift ? "Νυχτερινό" : ""}`,
        start_time: moment(e.start_time, "HH:mm").format("HH:mm"),
        end_time: moment(e.end_time, "HH:mm").format("HH:mm"),
        start: e.start_date,
        end: moment(e.end_date).add(1, "day").format("YYYY-MM-DD"),
        is_night_shift: e.is_night_shift,
        can_change: e.can_change,
        allDay: true,
        className: e.can_change
          ? "bg-success text-white"
          : "bg-danger text-white",
      }));

      this.calendarEvents = parsedData;
      return parsedData;
    },
    canChangeSchedule(scheduleId) {
      const event = this.calendarEvents.find(
        (e) => e.id === parseInt(scheduleId)
      );

      if (event) {
        return event.can_change;
      }
      return true;
    },
    validEditForm() {
      let isValid = true;
      if (!this.editevent.is_night_shift) {
        if (
          this.editevent.start_time &&
          this.editevent.end_time &&
          moment(this.editevent.start_time, "HH:mm").isSameOrAfter(
            moment(this.editevent.end_time, "HH:mm"),
            "minute"
          )
        ) {
          this.errors.end_time =
            "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
          isValid = false;
        } else {
          this.errors.end_time = "";
        }
      } else {
        if (
          this.editevent.start_time &&
          this.editevent.end_time &&
          moment(this.editevent.start_time, "HH:mm").isSameOrBefore(
            moment(this.editevent.end_time, "HH:mm"),
            "minute"
          )
        ) {
          this.errors.end_time =
            "Η ώρα λήξης πρέπει να είναι νωρίτερα από την ώρα έναρξης για τη νυχτερινή βάρδια.";
          isValid = false;
        } else {
          this.errors.end_time = "";
        }
      }

      return isValid;
    },

    validForm() {
      let isValid = true;
      if (!this.event.is_night_shift) {
        if (
          this.event.start_time &&
          this.event.end_time &&
          moment(this.event.start_time, "HH:mm").isSameOrAfter(
            moment(this.event.end_time, "HH:mm"),
            "minute"
          )
        ) {
          this.errors.end_time =
            "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
          isValid = false;
        } else {
          this.errors.end_time = "";
        }
      } else {
        if (
          this.event.start_time &&
          this.event.end_time &&
          moment(this.event.start_time, "HH:mm").isSameOrBefore(
            moment(this.event.end_time, "HH:mm"),
            "minute"
          )
        ) {
          this.errors.end_time =
            "Η ώρα λήξης πρέπει να είναι νωρίτερα από την ώρα έναρξης για τη νυχτερινή βάρδια.";
          isValid = false;
        } else {
          this.errors.end_time = "";
        }
      }

      return isValid;
    },
    handleEventDrop(info) {
      if (!this.canChangeSchedule(info.event.id)) {
        info.revert();
        return;
      }

      Swal.fire({
        title: "Είστε σίγουροι?",
        text: "Το πρόγραμμα θα αλλάξει!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Άκυρο",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι!",
      }).then((result) => {
        if (result.isConfirmed) {
          const event = info.event;
          // this.updateEvent(event);
          this.updateWorkingSchedule(event);

          // this.successmsg();

          // Swal.fire("Επιτυχία!", "Το πρόγραμμα έχει αλλάξει.", "success");
        } else {
          info.revert();
        }
      });
    },
    handleDateRangeSelect(selectionInfo) {
      this.newEventData = selectionInfo;
      this.showModal = true;
    },
    /**
     * Modal form submit
     */
    // eslint-disable-next-line no-unused-vars
    createWorkingSchedule(data) {
      return session
        .post("api/user/schedule/create/", data)
        .then((resp) => {
          this.refreshEvents();
          this.successmsg();
          return resp.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async handleSubmit() {
      if (!this.validForm()) {
        return;
      }
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const start_time = this.event.start_time;
        const end_time = this.event.end_time;
        const is_night_shift = this.event.is_night_shift;
        console.log(is_night_shift);
        // const isNightShift = this.event.is_night_shift;
        let calendarApi = this.newEventData.view.calendar;

        const weekdays = this.getWeekdays(
          this.newEventData.start,
          moment(this.newEventData.end).subtract(1, "day")
        ).map((e) => e.id);

        const data = {
          start_time: start_time,
          end_time: end_time,
          start_date: moment(this.newEventData.start).format("YYYY-MM-DD"),
          end_date: moment(this.newEventData.end)
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
          person: this.$route.params.id,
          weekdays: weekdays,
          is_night_shift: is_night_shift,
        };

        console.log(data);
        await this.createWorkingSchedule(data);

        calendarApi.refetchEvents();

        // this.currentEvents = calendarApi.addEvent({
        //   id: this.newEventData.length + 1,
        //   title: `${start_time}-${end_time} ${isNightShift ? "Νυχτερινό" : ""}`,
        //   start_time: start_time,
        //   end_time: end_time,
        //   is_night_shift: isNightShift,
        //   start: this.newEventData.start,
        //   end: this.newEventData.end,
        //   allDay: true,
        // });

        this.showModal = false;
        this.newEventData = {};
      }
      this.submitted = false;
      this.event = {};
    },
    // eslint-disable-next-line no-unused-vars
    hideModal(e) {
      this.submitted = false;
      this.showModal = false;
      this.event = {};
      this.errors = {
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
      };
    },
    /**
     * Edit event modal submit
     */
    // eslint-disable-next-line no-unused-vars
    editSubmit(e) {
      this.submit = true;
      const editStartTime = this.editevent.start_time;
      const editEndTime = this.editevent.end_time;
      const editIsNightShift = this.editevent.is_night_shift;
      const editTitle = `${editStartTime}-${editEndTime} ${
        editIsNightShift ? "Νυχτερινό" : ""
      }`;
      // this.event = {
      //   start_time: editStartTime,
      //   end_time: editEndTime,
      //   is_night_shift: editIsNightShift,
      // };
      if (!this.validEditForm()) {
        return;
      }

      this.edit.setProp("title", editTitle);
      this.edit.setExtendedProp("start_time", editStartTime);
      this.edit.setExtendedProp("end_time", editEndTime);
      this.edit.setExtendedProp("is_night_shift", editIsNightShift);
      this.event = {};
      this.updateWorkingSchedule(this.edit);
      this.edit = {};

      this.eventModal = false;
    },

    /**
     * Delete event
     */
    deleteWorkingSchedule() {
      const objectId = parseInt(this.edit.id);
      session
        .delete(`api/user/schedule/${objectId}/delete/`)
        .then(() => {
          Swal.fire("Διαγράφηκε!", "Tο πρόγραμμα έχει διαγραφεί.", "success");
          this.edit.remove();
          this.eventModal = false;
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            title: "Ουπς, πήγε κάτι στραβά!",
            text: "Παρακαλώ επικοινωνήστε με τους διαχειριστές!",
            icon: "danger",
          });
        });
    },
    deleteEvent() {
      this.deleteWorkingSchedule();
    },
    /**
     * Modal open for add event
     */
    dateClicked(info) {
      this.newEventData = info;
      this.showModal = true;
    },
    /**
     * Modal open for edit event
     */
    editEvent(info) {
      this.edit = info.event;
      if (!this.canChangeSchedule(this.edit.id)) {
        return;
      }

      this.editevent.start_time = this.edit.extendedProps.start_time;
      this.editevent.end_time = this.edit.extendedProps.end_time;
      this.editevent.is_night_shift = this.edit.extendedProps.is_night_shift;
      this.eventModal = true;
    },

    updateEvent(event) {
      const updatedEventIndex = this.calendarEvents.findIndex(
        (e) => e.id === parseInt(event.id)
      );

      if (updatedEventIndex !== -1) {
        this.$set(this.calendarEvents, updatedEventIndex, {
          id: event.id,
          title: event.title,
          start: event.start,
          start_time: event.extendedProps.start_time,
          end_time: event.extendedProps.end_time,
          is_night_shift: event.extendedProps.is_night_shift,
          can_change: event.extendedProps.can_change,
          end: event.end,
          allDay: true,
        });
      }
    },

    async refreshEvents() {
      // refresh the events
      const calendarApi = this.$refs.fullCalendar.getApi();
      const info = {
        start: calendarApi.view.activeStart,
        end: calendarApi.view.activeEnd,
      };

      this.fetchWorkingSchedule(
        info,
        (events) => {
          this.calendarEvents = events;
          // events.forEach((event) => calendarApi.addEvent(event));
        },
        (error) => {
          console.error("Error fetching events:", error);
        }
      );
    },

    closeModal() {
      this.eventModal = false;
      this.errors = {
        start_date: "",
        end_date: "",
        start_time: "",
        end_time: "",
      };
    },

    confirm() {
      Swal.fire({
        title: "Είστε σίγουροι?",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Άκυρο",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          this.deleteEvent();
        }
      });
    },
    /**
     * Show list of events
     */
    handleEvents(events) {
      this.currentEvents = events;
    },
    handleEventResize(eventResizeInfo) {
      if (!this.canChangeSchedule(eventResizeInfo.event.id)) {
        eventResizeInfo.revert();
        return;
      }

      Swal.fire({
        title: "Είστε σίγουροι?",
        text: "Το πρόγραμμα θα αλλάξει!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Άκυρο",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι!",
      }).then((result) => {
        if (result.isConfirmed) {
          const event = eventResizeInfo.event;
          event.setEnd(eventResizeInfo.endDelta);

          this.updateWorkingSchedule(eventResizeInfo.event);

          // Swal.fire("Επιτυχία!", "Το πρόγραμμα έχει αλλάξει.", "success");
        } else {
          eventResizeInfo.revert();
        }
      });
    },

    getWeekdays(start, end) {
      const startMoment = moment(start);
      const endMoment = moment(end);
      const weekdays = [];

      for (
        let date = startMoment.clone();
        date.isSameOrBefore(endMoment);
        date.add(1, "days")
      ) {
        if (!weekdays.includes(date.isoWeekday())) {
          weekdays.push({ id: date.isoWeekday() });
        }
      }

      return weekdays;
    },

    updateWorkingSchedule(info) {
      const data = {
        start_date: moment(info.start).format("YYYY-MM-DD"),
        end_date: moment(info.end).subtract(1, "day").format("YYYY-MM-DD"),
        is_night_shift: info.extendedProps.is_night_shift,
        start_time: info.extendedProps.start_time,
        end_time: info.extendedProps.end_time,
        weekdays: this.getWeekdays(
          info.start,
          moment(info.end).subtract(1, "day")
        ),
        person: this.$route.params.id,
      };

      const objectId = parseInt(info.id);
      session
        .put(`api/user/schedule/${objectId}/update/`, data)
        .then(() => {
          this.refreshEvents();
          // this.updateEvent(info);
          this.successmsg();
        })
        .catch((e) => {
          console.log(e);
          Swal.fire({
            title: "Ουπς, πήγε κάτι στραβά!",
            text: "Παρακαλώ επικοινωνήστε με τους διαχειριστές!",
            icon: "danger",
          });
        });
    },

    /**
     * Show successfull Save Dialog
     */
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Το πρόγραμμα έχει αποθηκευτεί",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    handleStartTimeChange() {
      if (
        !this.event.is_night_shift &&
        this.event.start_time &&
        this.event.end_time &&
        moment(this.event.start_time, "HH:mm").isSameOrAfter(
          moment(this.event.end_time, "HH:mm"),
          "minute"
        )
      ) {
        this.errors.end_time =
          "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
        this.isValidForm = false;
      } else {
        this.errors.end_time = "";
        this.isValidForm = true;
      }
    },
    handleEndTimeChange() {
      if (
        !this.event.is_night_shift &&
        this.event.start_time &&
        this.event.end_time &&
        moment(this.event.end_time, "HH:mm").isSameOrBefore(
          moment(this.event.start_time, "HH:mm"),
          "minute"
        )
      ) {
        this.errors.end_time =
          "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
        this.isValidForm = false;
      } else {
        this.errors.end_time = "";
        this.isValidForm = true;
      }
    },

    handleIsNightShift() {
      this.handleStartTimeChange();
      this.handleEndTimeChange();
    },

    handleEditStartTimeChange() {
      if (
        !this.editevent.is_night_shift &&
        this.editevent.start_time &&
        this.editevent.end_time &&
        moment(this.editevent.start_time, "HH:mm").isSameOrAfter(
          moment(this.editevent.end_time, "HH:mm"),
          "minute"
        )
      ) {
        this.errors.end_time =
          "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
        this.isValidForm = false;
      } else {
        this.errors.end_time = "";
        this.isValidForm = true;
      }
    },
    handleEditEndTimeChange() {
      if (
        !this.editevent.is_night_shift &&
        this.editevent.start_time &&
        this.editevent.end_time &&
        moment(this.editevent.end_time, "HH:mm").isSameOrBefore(
          moment(this.editevent.start_time, "HH:mm"),
          "minute"
        )
      ) {
        this.errors.end_time =
          "Η ώρα λήξης πρέπει να είναι μεταγενέστερη από την ώρα έναρξης.";
        this.isValidForm = false;
      } else {
        this.errors.end_time = "";
        this.isValidForm = true;
      }
    },
    handleEditIsNightShift() {
      this.handleEditStartTimeChange();
      this.handleEditEndTimeChange();
    },
  },
};
</script>


<style >
.fc-toolbar h2,
.fc-toolbar .h2 {
  text-transform: capitalize;
}
</style>



<style scoped>
::v-deep .custom-checkbox .form-check-input {
  width: 30px;
  height: 30px;
}
</style>


